import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function SystemModule() {
  return <ModuleNavigation moduleId="SystemModule" />;
}
